
<main>
    <div class="main-members donor-members" *ngFor="let data of donorListData">
        <a class="member-list-item" [routerLink]="['/committee/member-details/',data.user_id]">
            <ng-container [ngSwitch]="data.image !== ''">
                <img *ngSwitchCase="true" [src]="baseUrl + data.image" />
                <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
            </ng-container>
            <div>
                <h5>{{data.name}}</h5>
                <h6>{{data.village_name +', '+data.city_name+', '+data.district_name}}</h6>
                <p>{{data.contact_no}}</p>
            </div>
        </a>
       
    </div>
</main>